module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"home":"Restaurants","enter_address":"Enter your location","set_address":"Set location","change_address":"Change","self_pickup":"Self Pick Up"},"ja":{"home":"店舗一覧","enter_address":"住所を指定","set_address":"設定","change_address":"編集","self_pickup":"ピックアップ"}}')
}



//////////////////
// WEBPACK FOOTER
// ./~/@kazupon/vue-i18n-loader/lib!./~/yaml-loader!./~/vue-loader/lib/selector.js?type=customBlocks&index=1!./src/components/AppNav.vue
// module id = uBez
// module chunks = 14